import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';

import BlogText from 'Components/Blog/content/BlogText';
import ProductCard from 'Components/Blog/content/slices/ProductCard';

export default function RepeatingSlice({ body, Component }) {
  const closingText = get(body, 'primary.slice_text');

  return (
    <div className="blog-grouped-content">
      {body.items.map(item =>
        <div className="blog-grouped-content-item" key={Math.random()}>
          {get(item, 'title[0].text') && <h2 className="mb-3">{get(item, 'title[0].text')}</h2>}
          {!!Component &&
            <Component item={item} />
          }
          <BlogText elements={get(item, 'paragraph_text', [])} />
          {get(item, 'product_card', []).map(cardBody =>
            <ProductCard body={cardBody} key={Math.random()} />,
          )}
        </div>,
      )}
      {closingText &&
        <BlogText elements={closingText} />
      }
    </div>
  );
}

RepeatingSlice.propTypes = {
  body: PropTypes.shape({
    slice_type: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({})),
    primary: PropTypes.shape({}),
  }).isRequired,
  Component: PropTypes.elementType,
};

RepeatingSlice.defaultProps = {
  Component: null,
};
